import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import TickIcon from '@images/vms-account/vms-icons/Tick.svg';

interface ToggleProps {
  units: string[];
  currentUnit: string;
  setCurrentUnit: (a: string) => void;
}

const UnitSwapToggle: React.FC<ToggleProps> = ({ units, currentUnit, setCurrentUnit }) => {
  const renderButtons = () =>
    units.map((unit) => {
      const isActive = unit === currentUnit;
      return (
        <UnitToggle key={unit} type="button" $active={isActive} onClick={() => setCurrentUnit(unit)}>
          {isActive && <TickIcon style={{ height: 12 }} />}
          <span>{unit}</span>
        </UnitToggle>
      );
    });

  return <ToggleWrap>{renderButtons()}</ToggleWrap>;
};

export default UnitSwapToggle;

const ToggleWrap = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid ${Colors.gold};
  border-radius: 2px;
  align-self: flex-start;
  margin-top: 15px;
  gap: 1px;
`;

const UnitToggle = styled.button<{ $active: boolean }>`
  opacity: 1;
  background: ${(props) => (props.$active ? `${Colors.lilac}20` : Colors.cream)};
  color: ${Colors.navyBlue};
  font-family: 'BrownStd';
  font-size: 14px;
  line-height: 140%;
  font-weight: ${(props) => (props.$active ? 700 : 400)};
  border: ${(props) => (props.$active ? `1px solid ${Colors.lilac}` : 'none')};
  padding: 5px 12px;
  margin: ${(props) => (props.$active ? '-1px' : '0')};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  min-width: 75px;
`;
